// src/api/authApi.js
import { API_BASE_URL } from '../config/apiConfig';

const AUTH_TOKEN_KEY = 'shopping_auth_token';

const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const parseResponse = async (response) => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false) {
    const err = new Error(data.message || `HTTP Error: ${response.status}`);
    err.status = response.status;
    err.isAuthError = response.status === 401;
    throw err;
  }

  return data;
};

const authApi = {
  register: async ({ username, email, password }) => {
    const response = await fetch(`${API_BASE_URL}auth-register.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, email, password }),
    });

    return parseResponse(response);
  },

  login: async ({ login, password }) => {
    const response = await fetch(`${API_BASE_URL}auth-login.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login, password }),
    });

    return parseResponse(response);
  },

  logout: async () => {
    const response = await fetch(`${API_BASE_URL}auth-logout.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
    });

    return parseResponse(response);
  },

  me: async () => {
    const response = await fetch(`${API_BASE_URL}auth-me.php`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    return parseResponse(response);
  },
};

export { authApi, AUTH_TOKEN_KEY, getAuthToken, getAuthHeaders };
